import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=c9280efa&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=c9280efa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9280efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lighthouse/AED/mips/mips-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9280efa')) {
      api.createRecord('c9280efa', component.options)
    } else {
      api.reload('c9280efa', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=c9280efa&scoped=true", function () {
      api.rerender('c9280efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ips/editor/preview.vue"
export default component.exports